exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".checkbox-item[data-v-04c736ea]{cursor:pointer}.error[data-v-04c736ea]{color:#bc342d}.error .checkbox-icon[data-v-04c736ea]{fill:#bc342d}", ""]);

